//#region src/domain/i18n/language-code.ts
var LanguageCode = /* @__PURE__ */ function(LanguageCode) {
	LanguageCode["ES_DO"] = "es-DO";
	LanguageCode["ES_GT"] = "es-GT";
	LanguageCode["ES_HN"] = "es-HN";
	return LanguageCode;
}({});
//#endregion
export { LanguageCode };

//# sourceMappingURL=language-code.js.map